<span class="info_icon"
    [matTooltip]="text"
    (mouseenter)="$event.stopImmediatePropagation()"
    (mouseleave)="$event.stopImmediatePropagation()" 
    #tooltip="matTooltip"
    (click)="tooltip.show()"
    matTooltipPosition="after"
    matTooltipClass="custom-tooltip">
    <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
  </span>